import cx from 'classnames'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import styles from './SingleOccupancyCard.module.scss'

CollapsedNotification.propTypes = {
  isUpgraded: PropTypes.bool,
  setIsCollapsed: PropTypes.func.isRequired,
}

export default function CollapsedNotification({
  isUpgraded,
  setIsCollapsed,
}) {
  const expand = () => setIsCollapsed(false)
  return (
    <div
      className={styles.collapsed}
      onClick={expand}
      onKeyDown={(e) => e.key === 'Enter' && expand()}
      role='button'
      tabIndex={0}
    >
      {isUpgraded ? (
        <span className={styles.collapsedLabel}>
          <i className={cx('font-icons ok-icon', styles.collapseIcon)} />
          <FormattedMessage
            id='occupancy_selected'
            defaultMessage='Single occupancy upgrade selected'
          />
        </span>
      ) : (
        <span className={styles.collapsedLabel}>
          <i className={cx('font-icons fail-icon', styles.collapseIcon)} />
          <FormattedMessage
            id='occupancy_not_selected'
            defaultMessage='Single occupancy upgrade not selected'
          />
        </span>
      )}
      <span className={styles.change}>
        <FormattedMessage id='change' defaultMessage='Change' />
      </span>
    </div>
  )
}
